import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Attribution } from '../../models/Attribution';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { LotMarche } from '../../models/LotMarche';
import { CTRL_322 } from '../../../../validators/322/ctrl322';
import { Step5 } from '../../../../../shared/models/component-messages/diveAT/step5';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Component({
	selector: 'app-step5',
	templateUrl: './step5.component.html'
})
export class Step5Component implements OnInit {

	private LOG: LogService = new LogService(Step5Component);

	@Input() attribution: Attribution;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
	public current_uid = '';
	public rg4 = '_STEP_ID_5_' + CTRL_322.id + '_1';

	public step5 = new Step5();

	constructor(private formExtractorService: FormExtractorService,
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private avisDataTransferService: AvisDataTransferService
	) { }

	ngOnInit(): void {
	}

	getUid() {
		return this.uid + '_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution';
	}

	addlotMarche() {
		if(!this.attribution.lotMarche) {
			this.attribution.lotMarche = [];
		}
		this.attribution.lotMarche.push(new LotMarche());
	}

	removelotMarche(i: number) {
		this.attribution.lotMarche.splice(i, 1);
	}

	public getType() {
		return this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.attribution.resultatAttribution;
	}

	public isAttribue(): boolean {
		return this.getType() !== RadioCheckBoxEnum.sansSuite
		  && this.getType() !== RadioCheckBoxEnum.infructueux;
	  }
	
	public isAttributionParLots(): boolean {
	if (this.getType() === RadioCheckBoxEnum.attribueLots
		|| this.getType() === RadioCheckBoxEnum.lotsInfructueux) {
		this.parentForm.addControl(this.rg4, new FormControl({}));
		let lotMarcheIter = 1;
		for (const lot in this.attribution.lotMarche) {
			lotMarcheIter++;
		}
	}
	return this.getType() === RadioCheckBoxEnum.attribueLots
		|| this.getType() === RadioCheckBoxEnum.lotsInfructueux;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	  }

}
